import { Injectable } from '@angular/core';
import { TRANSLATIONS } from '@core/constants/translations';

export type TranslateParams = Array<string | number> | Record<string, string | number>;

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private readonly featureTranslations: Record<string, string> = {};

  addTranslations(translations: Record<string, string>): void {
    Object.assign(this.featureTranslations, translations);
  }

  translate(key: string, params?: TranslateParams): string {
    const normalizedKey = (key ?? '').toString().trim();
    if (!normalizedKey) {
      return key;
    }

    let translation =
      this.featureTranslations[normalizedKey] ??
      (TRANSLATIONS as Record<string, any>)[normalizedKey] ??
      resolvePath(TRANSLATIONS, normalizedKey);

    if (translation == null) {
      console.warn(`Translation key not found: ${normalizedKey}`);
      return normalizedKey;
    }

    // Replace parameters {0}, {1}, ... or {key} placeholders
    if (params) {
      if (Array.isArray(params)) {
        params.forEach((param, index) => {
          translation = translation.replaceAll(`{${index}}`, String(param));
        });
      } else {
        Object.keys(params).forEach((paramKey) => {
          translation = translation.replaceAll(`{${paramKey}}`, String(params[paramKey]));
        });
      }
    }

    return translation;
  }

  instant(key: string, params?: TranslateParams): string {
    return this.translate(key, params);
  }
}

function resolvePath(obj: Record<string, any>, path: string): string | undefined {
  if (!obj || !path) return undefined;
  const parts = path.split('.');
  let current: any = obj;
  for (const part of parts) {
    if (
      current &&
      typeof current === 'object' &&
      Object.prototype.hasOwnProperty.call(current, part)
    ) {
      current = current[part];
    } else {
      return undefined;
    }
  }
  return typeof current === 'string' ? current : undefined;
}
